import { customBaseQuery } from '@/lib/baseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from '@/shared/types';

export interface InfynityTokenResponse {
  ok: boolean;
  /** Six-digit OTP, or null when no code could be read from the screen. */
  token: string | null;
  /** Capture timestamp, formatted as `YYYYMMDD-HHMMSS`. */
  scan_time: string;
}

export interface InfynityTokenImageResponse extends InfynityTokenResponse {
  /** Base64-encoded PNG screenshot of the captured OTP. */
  image_base64: string;
}

export const odinOtpApi = createApi({
  reducerPath: 'odinOtpApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getInfynityToken: builder.query<InfynityTokenResponse, void>({
      query: () => ({
        url: 'v1/odin-otp/get-infynity-token',
        method: 'GET',
      }),
      transformResponse: (res: ApiResponse<InfynityTokenResponse>) => res.data,
    }),
    getInfynityTokenImage: builder.query<InfynityTokenImageResponse, void>({
      query: () => ({
        url: 'v1/odin-otp/get-token-image',
        method: 'GET',
      }),
      transformResponse: (res: ApiResponse<InfynityTokenImageResponse>) =>
        res.data,
    }),
  }),
});

export const { useGetInfynityTokenQuery, useLazyGetInfynityTokenImageQuery } =
  odinOtpApi;
